import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import ListGroup from "./common/listGroup";
import Input from "./common/input";
import Select from "./common/select";

const LayoutModal = ({
  show,
  layoutComponent,
  layoutConfig,
  layoutType,
  handleClose,
  handleChange,
  parameters,
  handleComponentChange,
  handleSubmit,
  handleAdd,
}) => {
  const components = [
    { id: 1, name: "TimeseriesChart" },
    { id: 2, name: "TimeseriesTable" },
  ];
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton className="bg-success text-white">
        <Modal.Title>Add Layout</Modal.Title>
      </Modal.Header>
      <form>
        <Modal.Body>
          <div className="row">
            <div className="col">
              <ListGroup
                items={components}
                onItemSelect={handleComponentChange}
                selectedItem={layoutComponent}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Input
                name="row"
                type="number"
                placeholder="Row Number"
                label="Row"
                value={layoutConfig.row}
                onChange={handleChange}
                min={1}
                max={12}
              />
            </div>
            <div className="col">
              <Input
                name="column"
                type="number"
                placeholder="Column Number"
                label="Column"
                value={layoutConfig.column}
                onChange={handleChange}
                min={1}
                max={12}
              />
            </div>
          </div>
          {layoutComponent.id === 1 ? (
            <ChartForm
              data={layoutConfig}
              parameters={parameters}
              handleChange={handleChange}
            />
          ) : (
            <TableForm
              data={layoutConfig}
              parameters={parameters}
              handleAdd={handleAdd}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-success" onClick={handleSubmit}>
            {layoutType === "Add" ? "Add" : "Update"}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

const ChartForm = ({ data, parameters, handleChange }) => {
  const chartTypes = [
    { id: "area", name: "Area" },
    { id: "scatter", name: "Scatter" },
    { id: "bar", name: "Bar" },
  ];
  const chartHeights = [
    { id: "", name: "" },
    { id: "small", name: "Small" },
    { id: "medium", name: "Medium" },
    { id: "large", name: "Large" },
  ];
  return (
    <>
      <div className="row">
        <div className="col">
          <Select
            name="parameter"
            options={parameters}
            placeholder="Code"
            label="Parameter"
            value={data.parameter}
            onChange={handleChange}
            listKey="PARM_CODE"
            listName="PARM_CODE"
          />
        </div>
        <div className="col">
          <Select
            name="type"
            options={chartTypes}
            placeholder="Type"
            label="Chart Type"
            value={data.type}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Input
            name="min"
            type="number"
            placeholder="Minimum"
            label="Min Y"
            value={data.min}
            onChange={handleChange}
          />
        </div>
        <div className="col">
          <Input
            name="max"
            type="number"
            placeholder="Maximum"
            label="Max Y"
            value={data.max}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Input
            name="target"
            type="number"
            placeholder="Target"
            label="Target"
            value={data.target}
            onChange={handleChange}
          />
        </div>
        <div className="col">
          <Select
            name="height"
            options={chartHeights}
            placeholder="Default"
            label="Height"
            value={data.height}
            onChange={handleChange}
          />
        </div>
      </div>
    </>
  );
};

const TableForm = ({ data, parameters, handleAdd }) => {
  const [code, setCode] = useState("");

  const onChange = ({ currentTarget: input }) => {
    setCode(input.value);
  };

  const addCode = (e) => {
    e.preventDefault();
    handleAdd(code);
    setCode("");
  };

  return (
    <>
      <div className="row align-items-end">
        <div className="col">
          <Select
            name="parameter"
            options={parameters}
            placeholder="Code"
            label="Parameter"
            value={code}
            onChange={onChange}
            listKey="PARM_CODE"
            listName="PARM_CODE"
          />
        </div>
        <div className="col-auto">
          <button className="btn btn-primary mb-3" onClick={addCode}>
            Add Code
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <h5>Parameters</h5>
          <ul className="list-group">
            {data.parameters.map((parmCode) => (
              <li key={parmCode} className="list-group-item">
                {parmCode}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default LayoutModal;
